const VERSION = "3.2.1";
export {
  VERSION
};
